import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  compose,
  withHandlers,
  setDisplayName,
  branch,
  renderNothing,
  withProps,
} from "recompose";
import { actions } from "../modules/contracts";
import { getConfirmedItems } from "../modules/items";
import WithTotals from "./WithTotals";
import _ from "lodash";
import { formatMoney } from "accounting";

const withSelectExpress = withHandlers({
  toggleExpress: ({
    setCurrentContract,
    updateContract,
    contract: { dealer, express, ...contract },
  }) => (ev) => {
    updateContract({
      dealer_id: dealer.id,
      contract_id: contract.tracking_number,
      data: Object.assign({}, contract, { express: !express }),
    }).then((resolvedContract) => setCurrentContract(resolvedContract));
  },
});

const withCondition = branch(
  ({ contract, role }) =>
    !(
      contract &&
      [
        "pending_diagnostic",
        "scheduled_scooter_pickup",
        "in_diagnostic",
        "approve_diagnostic",
        "customer_confirmation_needed",
      ].includes(contract.aasm_state) &&
      role === "customer" &&
      contract.dealer.available_express_services > 0
    ),
  renderNothing
);

const withState = connect(
  (state) => ({
    role: state.settings.role,
    contract: state.contracts.currentContract,
    items: getConfirmedItems(state),
  }),
  {
    updateContract: actions.updateContract,
    setCurrentContract: actions.setCurrentContract,
  }
);

const ExpressAdvice = ({
  contract: {
    express,
    items,
    dealer: { available_express_services, express_rate, express_rate_type },
  },
  contract,
  expressAmount,
  toggleExpress,
  isPlural,
  hasConfirmedItems,
  confirmedItems
}) => {
  const [upgradeAmount, setUpgradeAmount] = useState(0)

  useEffect(() => {
    function estimateUpgradeFee(){
      let sum = confirmedItems.reduce(function (accumulator, currentValue) {
          if (currentValue.type_service === "for_hours"){
            let laborFee = currentValue.labor_time ? parseFloat(contract.labor_rate) * parseFloat(currentValue.labor_time) : 0
            let partsFee = currentValue.part_price ? parseFloat(currentValue.part_price) : 0
            return accumulator + partsFee + laborFee
          } else {
            return accumulator + parseFloat(currentValue.flat_fee) 
          }
      }, 0)
      let upgradeFeeTotal = express_rate_type === "percent" ?  sum * express_rate : express_rate
      setUpgradeAmount(upgradeFeeTotal)
    }
    estimateUpgradeFee()
  }, [confirmedItems, contract.labor_rate, express_rate, express_rate_type])

  if (!express) {
    return (
      <>
        <label className="pb-3">
          We handle all repairs first-come first-serve. However, in some cases a
          customer’s scooter may be their primary transportation. If this is
          your case, you can rush your service for a fee.
        </label>
        <div
          className="w-100 btn btn-primary btn-fill rounded-lg selectable"
          onClick={toggleExpress}
        >
          Upgrade for {formatMoney(upgradeAmount)}
          {/* <FontAwesomeIcon icon={"check"} size="lg" /> */}
        </div>
      </>
    );
  } else {
    return (
      <div
        className="w-100 btn btn-primary rounded-lg selectable"
        onClick={toggleExpress}
      >
        Remove upgrade
      </div>
    );
  }
};

ExpressAdvice.propTypes = {
  items: PropTypes.array.isRequired,
  contract: PropTypes.object.isRequired,
};

export default compose(
  setDisplayName("EnhancedExpressAdvice"),
  withState,
  withSelectExpress,
  withCondition,
  WithTotals,
  withProps(({ contract, items }) => ({
    isPlural: _.get(contract, "dealer.available_express_services", 0) > 1,
    hasConfirmedItems: _.filter(items, { confirmed: true }).length >= 1,
  }))
)(ExpressAdvice);
